import React, { useEffect, useRef, useState } from 'react';
import styles from './style.module.scss';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
//import { Button } from 'components/buttons';
//import vid from './vid.mp4';
//import { set } from 'lodash';

export const SideTag = () => {
  let magicText = useRef(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (show) {
      const text = magicText.current;
      const chars = text.textContent.split('');

      text.innerHTML = '';

      // Wrap each character in a span
      chars.forEach((char) => {
        const span = document.createElement('span');
        span.textContent = char === ' ' ? '\u00A0' : char;
        span.style.display = 'inline-block';
        span.style.color = '#ffffff';
        text.appendChild(span);
      });

      const spans = text.querySelectorAll('span');
      const animatableSpans = Array.from(spans).filter(
        (span) => span.textContent.trim() !== ''
      );

      // Timeline with yoyo wave and delay between loops
      const tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 0.5,
        defaults: { ease: 'power1.inOut' },
      });

      tl.to(animatableSpans, {
        color: '#3f4251',
        duration: 3,
        stagger: 0.05,
      }).to(animatableSpans, {
        color: '#ffffff',
        duration: 1,
        stagger: 0.05,
      });
    }
  });

  return (
    <>
      {show && (
        <div className={styles['side-tag']}>
          <div className={styles['tag']}>
            <p ref={magicText}> lutron | orluna news</p>
          </div>
          <div className={styles['wrapper']}>
            <div>
              <video
                autoPlay="autoPlay"
                playsInline="playsInline"
                loop="loop"
                muted="muted"
              >
                <source
                  src="https://orluna-assets.weareinv.xyz/uploads/2025/06/Sequence-01_5.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <p>light & control coming together</p>
            <Link to="/news/lutron-orluna-announcement">
              <p className={styles['link-text']}>read more</p>
            </Link>
            <span
              onClick={() => {
                setShow(false);
              }}
              className={styles['close']}
            >
              X
            </span>
          </div>
        </div>
      )}
    </>
  );
};
